import { c as _c } from "react/compiler-runtime";
import { Icon } from '@udemy-v2/icons';
import { MarketplaceOnly } from '@udemy-v2/react-brand-components';
import { TextInputProps } from '@udemy-v2/react-form-components';
import { ButtonStyleType, Button, ButtonProps, IconButton } from '@udemy-v2/react-core-components';
import { useI18n } from '@udemy-v2/i18n';
import { FormGroup, TextInputContainer, TextInput } from '@udemy-v2/react-form-components';
import { safelySetInnerHTML } from '@udemy-v2/utils';
import classNames from 'classnames';
import React from 'react';

// import type {DiscountAttempt} from '@udemy-v2/api-shopping';

import { CartOptIn } from './cart-opt-in.react-component';
import { CouponForm } from './coupon-form.react-component';
import { MODES, ModesKeys, SOURCE_TYPE, DISCOUNT_STATUSES } from './constants';
import { DiscountAttempt, CouponStore } from '@udemy-v2/api-shopping';
import { isDiscountRemovable } from './utils';
import styles from './redeem-coupon.module.scss';
interface ValidDiscountProps {
  removeCoupon: () => void;
  attemptDiscount: DiscountAttempt;
  isInCheckoutPane?: boolean;
}
export function ValidDiscount(t0) {
  const $ = _c(39);
  const {
    removeCoupon,
    attemptDiscount,
    isInCheckoutPane: t1
  } = t0;
  const isInCheckoutPane = t1 === undefined ? false : t1;
  const {
    interpolate,
    gettext
  } = useI18n();
  if (attemptDiscount.status !== DISCOUNT_STATUSES.APPLIED) {
    return null;
  }
  let sourceTypeText;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== attemptDiscount.code || $[1] !== attemptDiscount.source_type || $[2] !== gettext || $[3] !== interpolate || $[4] !== isInCheckoutPane) {
    const translatedText = interpolate(gettext("<b>%(couponCode)s</b> is applied"), {
      couponCode: attemptDiscount.code || ""
    }, true);
    let t6;
    if ($[10] !== gettext) {
      t6 = gettext("Udemy coupon");
      $[10] = gettext;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== gettext) {
      t7 = gettext("Instructor coupon");
      $[12] = gettext;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] !== t6 || $[15] !== t7) {
      t8 = {
        UDEMY_COUPON: t6,
        INSTRUCTOR_COUPON: t7
      };
      $[14] = t6;
      $[15] = t7;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    const SOURCE_TYPE_TEXT = t8;
    sourceTypeText = null;
    bb0: switch (attemptDiscount.source_type) {
      case SOURCE_TYPE.UDEMY_COUPON:
        {
          sourceTypeText = SOURCE_TYPE_TEXT.UDEMY_COUPON;
          break bb0;
        }
      case SOURCE_TYPE.INSTRUCTOR_COUPON:
        {
          sourceTypeText = SOURCE_TYPE_TEXT.INSTRUCTOR_COUPON;
        }
    }
    t4 = "code";
    if ($[17] !== isInCheckoutPane) {
      t5 = classNames(styles.code, {
        [styles["code-in-checkout-pane"]]: isInCheckoutPane
      });
      $[17] = isInCheckoutPane;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    t3 = styles["code-text"];
    t2 = safelySetInnerHTML({
      descriptionOfCaller: "redeem-coupon:code-text",
      html: translatedText,
      dataPurpose: "code-text"
    });
    $[0] = attemptDiscount.code;
    $[1] = attemptDiscount.source_type;
    $[2] = gettext;
    $[3] = interpolate;
    $[4] = isInCheckoutPane;
    $[5] = sourceTypeText;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    sourceTypeText = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[19] !== t2) {
    t6 = <li {...t2} />;
    $[19] = t2;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== sourceTypeText) {
    t7 = sourceTypeText && <li>{sourceTypeText}</li>;
    $[21] = sourceTypeText;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t6 || $[24] !== t7) {
    t8 = <ul>{t6}{t7}</ul>;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t3 || $[27] !== t8) {
    t9 = <div className={t3}>{t8}</div>;
    $[26] = t3;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== attemptDiscount || $[30] !== gettext || $[31] !== isInCheckoutPane || $[32] !== removeCoupon) {
    t10 = isDiscountRemovable(attemptDiscount) && <IconButton className={styles["code-icon-btn"]} onClick={removeCoupon} udStyle="ghost" data-purpose="remove-coupon"><Icon glyph="close" label={gettext("Remove coupon")} color={isInCheckoutPane ? "neutral" : "info"} size="small" /></IconButton>;
    $[29] = attemptDiscount;
    $[30] = gettext;
    $[31] = isInCheckoutPane;
    $[32] = removeCoupon;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== t10 || $[35] !== t4 || $[36] !== t5 || $[37] !== t9) {
    t11 = <div data-purpose={t4} className={t5}>{t9}{t10}</div>;
    $[34] = t10;
    $[35] = t4;
    $[36] = t5;
    $[37] = t9;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  return t11;
}
interface EnableCouponInputModeButtonProps {
  onEnterInputMode: () => void;
  enableCouponInputModeButtonProps?: ButtonProps;
}
export function EnableCouponInputModeButton(t0) {
  const $ = _c(8);
  const {
    onEnterInputMode,
    enableCouponInputModeButtonProps: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const enableCouponInputModeButtonProps = t2;
  const {
    gettext
  } = useI18n();
  let t3;
  if ($[2] !== gettext) {
    t3 = gettext("Apply Coupon");
    $[2] = gettext;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== enableCouponInputModeButtonProps || $[5] !== onEnterInputMode || $[6] !== t3) {
    t4 = <Button udStyle="ghost" data-purpose="show-coupon-form" onClick={onEnterInputMode} {...enableCouponInputModeButtonProps}>{t3}</Button>;
    $[4] = enableCouponInputModeButtonProps;
    $[5] = onEnterInputMode;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
interface RemoveCouponButtonProps {
  onRemoveCoupon: () => void;
  removeCouponButtonProps?: ButtonProps;
}
export function RemoveCouponButton(t0) {
  const $ = _c(8);
  const {
    onRemoveCoupon,
    removeCouponButtonProps: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const removeCouponButtonProps = t2;
  const {
    gettext
  } = useI18n();
  let t3;
  if ($[2] !== gettext) {
    t3 = gettext("Remove Coupon");
    $[2] = gettext;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onRemoveCoupon || $[5] !== removeCouponButtonProps || $[6] !== t3) {
    t4 = <Button udStyle="ghost" data-purpose="remove-coupons" onClick={onRemoveCoupon} {...removeCouponButtonProps}>{t3}</Button>;
    $[4] = onRemoveCoupon;
    $[5] = removeCouponButtonProps;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
export interface RedeemCouponProps {
  currentMode: ModesKeys;
  currentDiscountAttempts: DiscountAttempt[];
  error?: string;
  submittedCode: string;
  inputCode: string;
  inputOnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputOnSubmit: () => void;
  inputIsDisabled: boolean;
  onEnterInputMode: () => void;
  removeCouponCode: (code: string) => () => void;
  className?: string;
  inputModeClassName?: string;
  enableCouponInputModeButtonProps?: ButtonProps;
  showCouponInputModeButton?: boolean;
  showTitle?: boolean;
  showCartOptIn?: boolean;
  isInCheckoutPane?: boolean;
  couponStore?: CouponStore;
  showDiscountsAsTextInput?: boolean;
  size?: TextInputProps['size'];
  submitButtonStyle?: ButtonStyleType;
}
export function RedeemCoupon({
  currentMode,
  currentDiscountAttempts,
  error,
  submittedCode,
  inputCode,
  inputOnChange,
  inputOnSubmit,
  inputIsDisabled,
  onEnterInputMode,
  removeCouponCode,
  className,
  inputModeClassName,
  enableCouponInputModeButtonProps = {},
  showCouponInputModeButton = true,
  showTitle = false,
  showCartOptIn = false,
  isInCheckoutPane = false,
  showDiscountsAsTextInput = false,
  couponStore,
  size,
  submitButtonStyle
}: RedeemCouponProps) {
  const {
    gettext,
    locale
  } = useI18n();
  const appliedDiscounts = currentDiscountAttempts.filter(discount => discount.status === DISCOUNT_STATUSES.APPLIED);
  const isInputMode = [MODES.INPUT, MODES.PENDING].includes(currentMode);
  const shouldHideCouponForm = !isInputMode;
  if (currentMode === MODES.OFF) {
    return null;
  }
  return <div className={classNames(styles.container, className, {
    [classNames(styles['input-mode'], inputModeClassName)]: isInputMode
  })} data-purpose="redeem-coupon-container" data-testid="redeem-coupon">
            {showTitle && <h3 className={styles.title} data-purpose="coupon-title">
                    {gettext('Coupons')}
                </h3>}

            <MarketplaceOnly>
                {showCartOptIn && couponStore && <CartOptIn couponStore={couponStore} />}
            </MarketplaceOnly>

            <>
                {appliedDiscounts.length > 0 && !showDiscountsAsTextInput && <div className={styles.codes}>
                        {appliedDiscounts.map((discount_0, index) => <ValidDiscount key={`discount-${discount_0.code}-${index}`} attemptDiscount={discount_0} removeCoupon={removeCouponCode(discount_0.code || '')} isInCheckoutPane={isInCheckoutPane} />)}
                    </div>}

                {showCouponInputModeButton && !isInCheckoutPane && <EnableCouponInputModeButton onEnterInputMode={onEnterInputMode} enableCouponInputModeButtonProps={{
        ...enableCouponInputModeButtonProps
      }} />}

                {!shouldHideCouponForm && <CouponForm onChange={inputOnChange} onSubmit={inputOnSubmit} disabled={inputIsDisabled} error={error} submittedCode={submittedCode} inputCode={inputCode} currentMode={currentMode} isInCheckoutPane={isInCheckoutPane} size={size} submitButtonStyle={submitButtonStyle} />}
                {showDiscountsAsTextInput && appliedDiscounts.length > 0 && <div className={styles['applied-discounts']}>
                        {appliedDiscounts.map((discount_1, idx) => {
          let noteText = undefined;
          if (discount_1.source_type === SOURCE_TYPE.INSTRUCTOR_COUPON) {
            noteText = gettext('Instructor coupon');
          }
          // For the text input display mode, don't show the source type unless there's a legal requirement (in this case, only in Japan)
          if (discount_1.source_type === SOURCE_TYPE.UDEMY_COUPON && locale === 'ja_JP') {
            noteText = gettext('Udemy coupon');
          }
          return <FormGroup label={gettext('Applied coupons')} labelProps={{
            className: 'ud-sr-only'
          }} note={noteText} key={idx}>
                                    <TextInputContainer>
                                        <TextInput value={discount_1.code} disabled={true} size={'small'} />
                                        <div className={styles['text-input-applied-coupon']}>
                                            <span className={classNames('ud-text-sm', styles['applied-text'])}>
                                                {gettext('Applied!')}
                                            </span>
                                            {isDiscountRemovable(discount_1) && <IconButton onClick={removeCouponCode(discount_1.code)} udStyle="ghost" size={'small'} className={styles['clear-button']}>
                                                    <Icon glyph="close" color="neutral" label={gettext('Remove coupon')} />
                                                </IconButton>}
                                        </div>
                                    </TextInputContainer>
                                </FormGroup>;
        })}
                    </div>}
            </>
        </div>;
}